module.exports = __webpack_public_path__ + "img/ComingSoon3.48c27093.png";